var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Mask_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#2b3d8b",
    strokeWidth: 1.5,
    fill: "#fff",
    d: "M14110 251h24v24h-24z"
  })), /*#__PURE__*/React.createElement("style", null, ".Mask_svg__c{stroke:#2b3d8b;stroke-width:1.5px;fill:none;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14110 -251)",
    clipPath: "url(#Mask_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Mask_svg__c",
    d: "M14118.5 260.922a1.415 1.415 0 11-2 0 1.415 1.415 0 012 0M14126.808 257.732a2.5 2.5 0 11-3.536 0 2.5 2.5 0 013.536 0M14129.54 269v-1a3 3 0 00-3-3h-3a3 3 0 00-3 3v1M14118.745 265.676h-2c-1.657 0-2.286.668-2.286 2.325v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14110 251h24v24h-24z",
    fill: "none"
  }))));
}

export default SvgMask;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Mask.svg
// module id = 867
// module chunks = 101